<template>
    <a
        v-if="slaask.show"
        class="text-brand my-auto block cursor-pointer rounded-full px-1 py-1.5 text-sm lg:hidden"
        @click="slaask.toggleChat"
    >
        <SvgIcon
            class="text-brand h-5 w-5"
            :name="slaask.chatOpen ? 'system-close' : 'system-chat'"
        />
    </a>
</template>

<script setup>
import { useAppStore } from '@/store';

const { slaask } = useAppStore();
</script>
